module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/img/opponent-nate-diaz-3.d31830e8.png";